export default "__VITE_ASSET__91d471aa__"